module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_badia_sm-61d44d848342b514ec13dcd3fc5ebc81.png";